import PaginationMetaDetails from "./PaginationMetaDetails";
import PreviousButton from "./PreviousButton";
import NextButton from "./NextButton";
import PageNumber from "./PageNumber";

function Pagination({ pagination, loading, handlePageChange }) {
    return (
        pagination.total > 0 && (
            <div className="pagination">

                <PaginationMetaDetails pagination={pagination} />

                <PreviousButton pagination={pagination} loading={loading} handlePageChange={handlePageChange} />

                <PageNumber pagination={pagination} loading={loading} handlePageChange={handlePageChange} />

                <NextButton pagination={pagination} loading={loading} handlePageChange={handlePageChange} />

            </div>
        )
    );
}

export default Pagination;